export const INTEREST_RATE_FREQUENCY = {
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY"
};
